import { useEffect, useState } from 'react'
import { Studio } from './components/Studio'
import { resolveMediaPipeAssets, type MediaPipeAssets } from './lib/assets'

/**
 * Boot shell. Works out where the MediaPipe wasm and model are coming from
 * before the studio mounts, so the gate is constructed with the right paths
 * and never has to be torn down and rebuilt.
 */
export default function App() {
  const [assets, setAssets] = useState<MediaPipeAssets | null>(null)

  useEffect(() => {
    let alive = true
    resolveMediaPipeAssets()
      .then((a) => alive && setAssets(a))
      .catch(() => alive && setAssets({ selfHosted: false, note: null }))
    return () => {
      alive = false
    }
  }, [])

  if (!assets) {
    return (
      <div className="app-shell grid min-h-full place-items-center">
        <div className="flex items-center gap-2 font-mono text-xs text-faint">
          <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-accent" />
          eyecontact
        </div>
      </div>
    )
  }

  return <Studio assets={assets} />
}
